import styled from "styled-components";
import { colors } from "theme";

export const Option = styled.div`
  padding: 1.6rem 6rem;
  user-select: none;
  margin-left: 2rem;
  border: 1px solid ${colors.baseBlue};
  border-radius: 10px;
  cursor: pointer;
  font-size: 14px;
  background-color: ${(props) =>
    props.selected ? colors.baseBlue : "transparent"};
  color: ${(props) => (props.selected ? colors.whiteColor : colors.baseBlue)};
  transition: 0.2s ease-in-out all;
  &:hover {
    background-color: ${(props) =>
      props.selected ? "none" : colors.cardBackgroundColor};
    border: 1px solid
      ${(props) => (props.selected ? colors.baseBlue : colors.accentColor)};
    transform: scale(1.015);
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
  }
`;

export const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  transition: 0.2s ease-in-out all;
`;

export const TpaDetailInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top:  ${(props) => (props.marginTop ? props.marginTop : "0")};
  & > div {
    width: 100%;
    margin-bottom: 0.9rem;
  }
`;

export const OuterDiv = styled.div`
  display: flex;
  justify-content: left;
  max-width: 800px;
`
export const AttributeDetailWrapper = styled.div`
  padding: 2rem;
  padding-top: 1rem;
  background-color: #F5FCFF;
  border-radius: 10px;
  margin-bottom: 2rem;
  grid-column: 1/6;
`

export const Error = styled.p`
  color: red;
  font-size: 1.2rem;
  margin-top: 0.8rem;
`

export const TableGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  align-items: center;
`